<template>
  <div class="applicatorTable">
    <div class="ContainerSearchInput">
      <b-button class="BtnRegister" @click="openModalToReceive({})">
        <b-icon-plus scale="1.5" class="plus" />
        <span>Novo Aplicador</span>
      </b-button>
      <div class="searchInput" style="height: 100%; align-items: flex-end">
        <b-form-select
          v-if="showFilterTypes"
          v-model="filterType"
          size="sm"
          :options="filterTypes"
          class="searchFilterTypes"
        />
        <b-form-select
          v-model="type"
          size="sm"
          :options="filterCombobox"
          class="searchFilter"
          :style="showFilterTypes && 'border-left: none; border-radius: 0'"
          @change="showFilterTypes = !!type"
        />
        <b-input v-model="textPesquisa" size="sm" class="inputSearch" placeholder="Pesquisar" @keyup.enter="search" />
        <b-button size="sm" class="searchBtn" @click="search"><b-icon-search /></b-button>
        <button class="searchAll" @click="resetSearch"><b-icon-arrow-counterclockwise scale="1.3" /></button>
      </div>
      <div class="textRegister"><b-icon-person-lines-fill class="mr-1" />Aplicadores Registrados - {{ counter.applicatorCount || 0 }}</div>
    </div>

    <div v-if="dataApplicators.length" class="ContentTable">
      <div class="headerTable">
        <div class="celTable" style="width: 30%">Nome</div>
        <div class="celTable" style="width: 20%">CPF/CNPJ</div>
        <div class="celTable" style="width: 20%">Nº Registro</div>
        <div class="celTable" style="width: 20%">Contato</div>
        <div class="celTableActions">Ações</div>
      </div>
      <div v-for="item in dataApplicators" :key="item.id" class="rowSupplier" @click="findById(item.id)">
        <div class="celTable name" style="width: 30%">{{ item.nomeAplicador }}</div>
        <div class="celTable" style="width: 20%">{{ item.cpfCnpj || '--' }}</div>
        <div class="celTable" style="width: 20%">{{ item.numeroRegistro || 'Sem Informações' }}</div>
        <div class="celTable" style="width: 20%">{{ item.celular || item.telefone || '--' }}</div>
        <div class="celTableActions">
          <span v-b-tooltip.hover.top="'Excluir'" class="celInfos" @click.stop="handleOpenModal(item.id)">
            <b-icon-trash-fill scale="1.5" />
          </span>
        </div>
      </div>
    </div>
    <div v-else class="defaultSearch">Não há dados para exibir ...</div>
    <div v-if="spinGeneral" class="loadingLazy"><b-spinner /></div>
    <div class="setBtn">
      <button class="itemBtn" :disabled="page === 1" @click="previousPage"><b-icon-chevron-left /></button>
      <button class="centerItemBtn">{{ page }}</button>
      <button class="itemBtn" :disabled="dataApplicators.length < 9" @click="nextPage"><b-icon-chevron-right /></button>
    </div>
    <ModalConfirm
      modalName="modal-confirm-delete-applicator"
      title="Remover Aplicador"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="destroyApplicator"
      @modalClosed="selectedApplicatorId = null"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import ModalConfirm from '../Modals/ModalConfirm.vue';
import api from '../../services/axios';
import serviceRegisters from '../../services/serviceRegisters';
import toastAlertErros from '../../utils/toastAlertErros';

export default {
  components: { ModalConfirm },
  data() {
    return {
      counter: {}, dataApplicators: [], textPesquisa: '', type: '', page: 1,
      filterType: 'includes', showFilterTypes: false, spinGeneral: false, selectedApplicatorId: null,
      filterCombobox: [
        { value: '', text: 'Todos' }, { value: 'nomeAplicador', text: 'Nome' },
        { value: 'cpfCnpj', text: 'CPF/CNPJ' }, { value: 'numeroRegistro', text: 'Nº Registro' },
        { value: 'celular', text: 'Contato' }, { value: 'status', text: 'Status' },
      ],
      filterTypes: [{ value: 'includes', text: 'Contém' }, { value: 'start', text: 'Inicia por' }],
    };
  },
  computed: { ...mapState({ isSearchRegisters: (state) => state.isSearchRegisters }) },
  watch: { isSearchRegisters() { this.readApplicators(); } },
  created() { this.readApplicators(); },
  methods: {
    ...mapMutations([
      'ALTER_SIZE_MODAL_REGISTER', 'ALTER_TYPE_REGISTER', 'SET_COLAPSE_REGISTER',
      'ALTER_MODAL_CONTAINER_REGISTER', 'SET_DATA_SEARCH_FROM_APPLICATOR',
    ]),
    async readApplicators() {
      try {
        this.spinGeneral = true;
        const { data } = await api.get('/applicators/filter/search/parameters', {
          params: { q: this.textPesquisa, type: this.type, page: this.page, filterType: this.filterType },
        });
        this.dataApplicators = data.data;
        this.counter = await serviceRegisters.countAll();
      } catch (error) {
        this.$toast.open({ message: 'Não foi possível listar os aplicadores', type: 'warning' });
      } finally { this.spinGeneral = false; }
    },
    search() { this.page = 1; this.readApplicators(); },
    resetSearch() { this.textPesquisa = ''; this.type = ''; this.showFilterTypes = false; this.search(); },
    nextPage() { this.page++; this.readApplicators(); },
    previousPage() { if (this.page > 1) { this.page--; this.readApplicators(); } },
    async findById(id) {
      try {
        const { data } = await api.get(`/applicators/${id}`);
        this.openModalToReceive(data);
      } catch (error) { toastAlertErros.validateMessage(error, this.$toast); }
    },
    openModalToReceive(applicator) {
      this.SET_DATA_SEARCH_FROM_APPLICATOR(applicator);
      this.ALTER_TYPE_REGISTER('applicator');
      this.ALTER_SIZE_MODAL_REGISTER('ModalGeneral');
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER('modalContainer');
    },
    handleOpenModal(id) {
      this.selectedApplicatorId = id;
      this.$bvModal.show('modal-confirm-delete-applicator');
    },
    async destroyApplicator() {
      try {
        await api.delete(`/applicators/${this.selectedApplicatorId}`);
        await this.readApplicators();
        this.$toast.open({ message: 'Aplicador deletado!', type: 'success' });
      } catch (error) { toastAlertErros.validateMessage(error, this.$toast); }
    },
  },
};
</script>

<style scoped>
.applicatorTable { position: relative; min-height: 75vh; }
.ContainerSearchInput { display: flex; align-items: center; justify-content: space-between; gap: 10px; height: 37px; }
.BtnRegister { width: 200px; margin: 0 10px; padding: 0 !important; display: flex; align-items: center; justify-content: space-between; background: #e3ebe2; color: #006458; border: 1px solid #cfe5e3; font-size: 13px; height: 30px; }
.BtnRegister span { flex: 1; }
.BtnRegister:hover { background: whitesmoke; color: #006458; border-color: #006458; }
.plus { width: 30px; height: 30px; background: #006458; color: white; border-radius: 3px; }
.searchInput { width: 40%; display: flex; }
.searchFilter, .searchFilterTypes { width: 150px; height: 30px; font-size: 11px; text-align: center; border-right: none; }
.searchFilter:focus, .searchFilterTypes:focus { box-shadow: none; border: 1px solid #c3c1c1; }
.custom-select { left: 4px; position: relative; border-right: none; border-radius: 5px 0 0 5px; border: 1px solid #c3c1c1; appearance: none; }
.form-control-sm { padding: 0.25rem 1.5rem; height: 30px; }
.inputSearch { border: 1px solid #c3c1c1; border-radius: 5px; height: 30px; }
.inputSearch:focus { box-shadow: none; border-color: #c3c1c1; }
.searchBtn { right: 10px; height: 30px; position: relative; background: whitesmoke; color: black; border-radius: 0 5px 5px 0; border-left: none; border-color: #c3c1c1; }
.searchAll { display: flex; align-items: center; justify-content: center; height: 30px; padding: 5px; font-size: 13px; font-weight: bold; color: #3a4750; border: 1px solid #e3e0e0; border-radius: 5px; cursor: pointer; }
.searchAll:hover { background: #cdcdcd; }
.textRegister { padding: 0 10px; border-left: 1px solid #e1e1e1; color: #006458; white-space: nowrap; }
.ContentTable { padding: 10px; display: flex; flex-direction: column; gap: 5px; height: 70vh; overflow: auto; }
.headerTable { display: flex; align-items: center; background: #006256; color: white; border-radius: 5px 5px 0 0; font-weight: bold; height: 30px; }
.rowSupplier { display: flex; align-items: center; text-align: center; padding: 0 10px; height: 40px; flex-shrink: 0; background: #f8f8f8; border: 1px solid #e3ebe2; cursor: pointer; font-size: 12px; }
.rowSupplier:hover { background: #f2f2f2; }
.celTable { text-align: center; }
.name { color: #006458; font-weight: bold; text-transform: uppercase; }
.celTableActions { width: 10%; display: flex; justify-content: center; }
.celInfos { background: #e3ebe2; color: #006458; width: 30px; height: 30px; border-radius: 5px; display: flex; align-items: center; justify-content: center; }
.defaultSearch { height: 40vh; display: flex; align-items: center; justify-content: center; color: gray; font-weight: bold; }
.loadingLazy { position: absolute; top: 35%; left: 50%; }
.setBtn { position: absolute; right: 10px; bottom: 0; display: flex; gap: 5px; }
.itemBtn, .centerItemBtn { width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; color: #006458; border: 1px solid #aeaeae; border-radius: 3px; }
.itemBtn:disabled { opacity: 0; }
.centerItemBtn { background: #006458; color: white; }
@media (max-width: 700px) { .ContainerSearchInput { height: auto; flex-wrap: wrap; } .searchInput { width: 100%; } .textRegister { margin: 5px 10px; } .ContentTable { overflow-x: auto; } .headerTable, .rowSupplier { min-width: 600px; } }
</style>
